import { useSelector } from 'react-redux';
import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { selectChosenPlan, selectHasFiber } from '@app/redux';

const SatellitePrimaryAttribute = () => {
  const { t } = useTranslation('ChangePlan');
  const { characteristics } = useSelector(selectChosenPlan);

  return (
    <div data-cy="data-cap-primary-attribute">
      <div>
        <Txt component="span" variant="heading2">
          {characteristics.dataCap}
        </Txt>
        <Txt component="span" variant="bodySmallBold" ml="4px">
          {characteristics.dataCapUnits}
        </Txt>
      </div>
      <Txt variant="smallRegular" color="inherit">
        {t('orderReview.cartDetails.highSpeedData')}
      </Txt>
    </div>
  );
};

const FiberPrimaryAttribute = () => {
  const { t } = useTranslation('ChangePlan');
  const { characteristics } = useSelector(selectChosenPlan);

  return (
    <div data-cy="fiber-primary-attribute">
      <div>
        <Txt variant="heading5">{characteristics.offerName}</Txt>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Txt variant="smallRegular" color="subtle" mr="4px">
            {characteristics.dataAllowanceText}
          </Txt>
          <Txt variant="smallRegular" color="subtle">
            {t('orderReview.cartDetails.highSpeedData')}
          </Txt>
        </div>
      </div>
    </div>
  );
};

const PrimaryAttribute = () => {
  const isFiber = useSelector(selectHasFiber);
  return isFiber ? <FiberPrimaryAttribute /> : <SatellitePrimaryAttribute />;
};

export default PrimaryAttribute;
